<script>
    import { onDestroy } from "svelte";

    import PortalViewForm from "./components/PortalViewForm.svelte";
    import PortalViewHeader from "./components/PortalViewHeader.svelte";

    export let fontFamilyConfig = {};
    export let topHeaderConfig = {};
    export let formConfig = {};

    let fontLinkElement = null;
    let customFontClass = "";

    // analysis url get font family
    const extractFontFamilyFromUrl = (url) => {
        const regex = /family=([^&]+)/;
        const match = url.match(regex);
        if (match) {
            let fontFamily = match[1].split(":")[0].replace(/\+/g, " ");
            return fontFamily;
        }
        return null;
    };

    $: {
        if (
            (fontFamilyConfig.usingURLFont && fontFamilyConfig.fontUrl) ||
            fontFamilyConfig.fontUrl
        ) {
            const fontName = extractFontFamilyFromUrl(fontFamilyConfig.fontUrl);
            if (fontName) {
                customFontClass = fontName;

                if (
                    fontLinkElement &&
                    document.head.contains(fontLinkElement)
                ) {
                    document.head.removeChild(fontLinkElement);
                }

                fontLinkElement = document.createElement("link");
                fontLinkElement.rel = "stylesheet";
                fontLinkElement.href = fontFamilyConfig.fontUrl;

                fontLinkElement.onload = () => {
                    customFontClass = `"${fontName}", Azo Sans, sans-serif`;
                };

                document.head.appendChild(fontLinkElement);
            }
        } else {
            customFontClass = fontFamilyConfig?.systemFont || "sans-serif";
            if (fontLinkElement && document.head.contains(fontLinkElement)) {
                document.head.removeChild(fontLinkElement);
            }
        }
    }

    onDestroy(() => {
        if (fontLinkElement && document.head.contains(fontLinkElement)) {
            document.head.removeChild(fontLinkElement);
        }
    });
</script>

<div
    class="flex flex-col gap-y-2 max-w-[600px]"
    style="font-family: {customFontClass || 'Azo Sans, sans-serif'}"
>
    <p class="text-lg font-bold" style="font-family: 'Azo Sans, sans-serif';">
        Preview:
    </p>

    <PortalViewHeader {topHeaderConfig} />
    <PortalViewForm {formConfig} />
</div>
